export const FILTER_ALL = 'ALL';
export const PHASE_FILTER_ARCHIVED = 'ARCHIVED';
